angular.module('access.Utils')
    .factory('EmptyResponseHandler', ['$q', function ($q) {
        return {
            response: function (response) {
                if (
                    response.config.failOnEmptyResponse === true &&
                    (response.status === 204 || response.data === '')
                ) {
                    return $q.reject(new Error('Unexpected empty response (' + response.config.url + ')'));
                }

                return response;
            }
        }
    }]);

